var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l(([1,2,3,4,5]),function(level){return _c('span',{key:level,staticClass:"v-rating",on:{"click":function($event){return _vm.changeValue(level)}}},[_c('starSVG',{class:_vm.getClassName(level)})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }